import { useEffect, useState } from 'react';
import settings from '../../config/settings';
import { getCookieCategoriesAcceptance } from '../RouteWrapper/CookieInformation';

export const useEnableTracking = () => {
  const [enableTracking, setEnableTracking] = useState(getCookieCategoriesAcceptance().statistic);

  useEffect(() => {
    window.addEventListener('CookieInformationConsentGiven', function (event: any) {
      if (event.target.location.origin !== settings.application.url) {
        return;
      }

      setEnableTracking(getCookieCategoriesAcceptance().statistic);
    }, false);
  }, []);

  return enableTracking;
};
